import { useParams } from "react-router-dom";
import { FormatIndianDate } from "../../../../../app/utility/formatIndianDate";
import { useEffect, useState } from "react";
import { Breadcrumb } from "../../../../../components/breadcum";
import { CRMService } from "../../../../../app/core/crm.service";

export const Reminders = () => {
    const todayDate = new Date().toISOString().split("T")[0];
    // console.log(new Date("2025-08-15T08:00:00.000Z").toISOString().split("T")[0],todayDate);
    const params = useParams();
    const [reminderList, setRemainderList] = useState<any>([]);

    useEffect(() => {
        getRemaindersData();
        //     setRemainderList([{
        //     id: 1,
        //     time: "10:00 AM",
        //     date: new Date().toISOString().split("T")[0],
        //     remainder_details: { shop_name: "Sai Ram General Store", owner_name: "Srinivas Rao" },
        //     description: "Follow-up with client about proposal.",
        //     status: "COMPLETED"
        // },
        // {
        //     id: 2,
        //     time: "08:00 PM",
        //     date: new Date().toISOString().split("T")[0],
        //     remainder_details: { shop_name: "Sri Sai Kirana and General", owner_name: "Ravi Teja" },
        //     description: "Call with sri sai enterprises.Discuss for vyapar live project full details.",
        //     status: "SCHEDULED"
        // },
        // {
        //     id: 3,
        //     time: "02:00 PM",
        //     date: "2025-07-24",
        //     remainder_details: { shop_name: "Manikanta Kirana & Provisions", owner_name: "Suresh Babu" },
        //     description: "Schedule webinar invite email.",
        //     status: "SCHEDULED"
        // },
        // {
        //     id: 4,
        //     time: "11:00 AM",
        //     date: "2025-07-25",
        //     remainder_details: { shop_name: "Sri Durga Kirana", owner_name: "Mallikarjun Rao" },
        //     description: "Demo with XYZ Pvt Ltd - Product Overview.",
        //     status: "CANCELLED"
        // },
        // {
        //     id: 5,
        //     time: "1:00 pM",
        //     date: "2025-07-25",
        //     remainder_details: { shop_name: "Sri Durga Kirana", owner_name: "Mallikarjun Rao" },
        //     description: "Demo with XYZ Pvt Ltd - Product Overview.",
        //     status: "SCHEDULED"
        // }]);

    }, []);

    const getRemaindersData = async () => {
        try {
            let payload = {
                ...(params.id && { cId: params.id }),
                type: "reminders"
            }
            const res = await CRMService.GET_NOTES(payload);
            const resData = res?.results || [];
            setRemainderList(resData);
            console.log(resData, "resData");
        }
        catch (err) { }
    }
    const todayReminders = reminderList.filter((item: any) => item.date === todayDate);
    const upcomingReminders = reminderList.filter((item: any) => item.date > todayDate);
    const completedReminders = reminderList.filter((item: any) => item.date < todayDate);

    const [breadcrumbInfo, setBreadcrumbInfo] = useState<any>([
        {
            label: "customer list",
            value: "customer list",
            routerLink: `/dashboard/crm/vendors-list`,
            isActive: false,
        },
        {
            label: "Reminders",
            value: "Reminders",
            routerLink: ``,
            isActive: true,
        },
    ]);

    return (
        <div className={`${params.id ? "" : "container-fluid content-bg-color"}`}>
            {!params.id && <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>}
            <div className={`d-flex justify-content-between align-items-center ${!params.id ? "" : "mt-3"}`}>
                <h5 className="mb-0 fw-bold">Reminders</h5>
                {/* <button className="btn btn-primary rounded border-0 fs-14" onClick={handleShow}>Add Reminder</button> */}
            </div>
            {todayReminders.length > 0 && (
                <>
                    <h6 className="text-dark my-3 fw-bold">Today</h6>
                    {todayReminders.map((value: any, index: any) => (
                        <div key={`today-${index}`} className="card my-2 rounded-3" style={{ borderLeft: `5px solid ${value.status === "COMPLETED" ? "#00a86b" : value.status === "CANCELLED" ? "#F4364C" : "blue"}` }}>
                            <div className="card-body">
                                <div className="row align-items">
                                    <div className="col-md-2 fs-6 fw-bold right-border"><div>{FormatIndianDate(value.date, "")}</div><span>{value.time}</span></div>
                                    {!params.id && <div className="col-md-3 fs-14"><div>{value.remainder_details?.shop_name}</div><div>{value.remainder_details?.owner_name}</div></div>}
                                    <div className={`${!params.id ? "col-md-4" : "col-md-6"}`}>{value.description}</div>
                                    <div className="col-md-3"><div className="fs-12 fw-bold d-flex align-items-center">
                                        <span
                                            style={{
                                                height: "10px",
                                                width: "10px",
                                                borderRadius: "50%",
                                                backgroundColor:
                                                    value.status === "COMPLETED"
                                                        ? "green"
                                                        : value.status === "CANCELLED"
                                                            ? "red"
                                                            : "blue",
                                                display: "inline-block",
                                                marginRight: "8px",
                                            }}
                                        ></span>
                                        <span style={{ color: value.status === "COMPLETED" ? "green" : value.status === "CANCELLED" ? "red" : "blue" }}>
                                            {value?.status}
                                        </span>
                                    </div></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}

            {upcomingReminders.length > 0 && (
                <>
                    <h6 className="my-3 text-dark fw-bold">Upcoming</h6>
                    {upcomingReminders.map((value: any, index: any) => (
                        <div key={`upcoming-${index}`} className="card my-2 rounded-3" style={{ borderLeft: `5px solid ${value.status === "COMPLETED" ? "#00a86b" : value.status === "CANCELLED" ? "#F4364C" : "blue"}` }}>
                            <div className="card-body">
                                <div className="row align-items">
                                    <div className="col-md-2 fs-6 fw-bold right-border"><div>{FormatIndianDate(value.date, "")}</div><span>{value.time}</span></div>
                                    {!params.id && <div className="col-md-3 fs-14"><div>{value.remainder_details?.shop_name}</div><div>{value.remainder_details?.owner_name}</div></div>}
                                    <div className={`${!params.id ? "col-md-4" : "col-md-6"}`}>{value.description}</div>
                                    <div className="col-md-3" ><div className="fs-12 fw-bold d-flex align-items-center">
                                        <span
                                            style={{
                                                height: "10px",
                                                width: "10px",
                                                borderRadius: "50%",
                                                backgroundColor:
                                                    value.status === "COMPLETED"
                                                        ? "green"
                                                        : value.status === "CANCELLED"
                                                            ? "red"
                                                            : "blue",
                                                display: "inline-block",
                                                marginRight: "8px",
                                            }}
                                        ></span>
                                        <span style={{ color: value.status === "COMPLETED" ? "green" : value.status === "CANCELLED" ? "red" : "blue" }}>
                                            {value?.status}
                                        </span>
                                    </div></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}

            {completedReminders.length > 0 && (
                <>
                    <h6 className="my-3 text-dark fw-bold">Completed</h6>
                    {completedReminders.map((value: any, index: any) => (
                        <div key={`upcoming-${index}`} className="card my-2 rounded-3" style={{ borderLeft: `5px solid ${value.status === "COMPLETED" ? "#00a86b" : value.status === "CANCELLED" ? "#F4364C" : "blue"}` }}>
                            <div className="card-body">
                                <div className="row align-items">
                                    <div className="col-md-2 fs-6 fw-bold right-border"><div>{FormatIndianDate(value.date, "")}</div><span>{value.time}</span></div>
                                    {!params.id && <div className="col-md-3 fs-14"><div>{value.remainder_details?.shop_name}</div><div>{value.remainder_details?.owner_name}</div></div>}
                                    <div className={`${!params.id ? "col-md-4" : "col-md-6"}`}>{value.description}</div>
                                    <div className="col-md-3" ><div className="fs-12 fw-bold d-flex align-items-center">
                                        <span
                                            style={{
                                                height: "10px",
                                                width: "10px",
                                                borderRadius: "50%",
                                                backgroundColor:
                                                    value.status === "COMPLETED"
                                                        ? "green"
                                                        : value.status === "CANCELLED"
                                                            ? "red"
                                                            : "blue",
                                                display: "inline-block",
                                                marginRight: "8px",
                                            }}
                                        ></span>
                                        <span style={{ color: value.status === "COMPLETED" ? "green" : value.status === "CANCELLED" ? "red" : "blue" }}>
                                            {value?.status}
                                        </span>
                                    </div></div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}

        </div>
    )
}
